import {GeneralAction} from "../../@types/actions";
import {SET_BETFAIR_REFS} from "../../constants/CommonConstants";

export const SetBetfairRefsAction = (event: any): GeneralAction<any> => ({
    type: SET_BETFAIR_REFS,
    payload: event
});
